import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { WORLDS } from "@/lib/worlds";
import { SITE, useCompany, companyLine } from "@/lib/site";

const COLS = [
  {
    title: "Fable +",
    links: [
      ["/marketplace", "Marketplace"],
      ["/events", "Events"],
      ["/shop", "Shop"],
      ["/yasmin", "Yasmin"],
      ["/travel", "Travel"],
      ["/get-the-app", "Get the app"],
    ],
  },
  {
    title: "Stage",
    links: [
      ["/stage/feed", "Pulse feed"],
      ["/stage/reels", "Reels"],
      ["/stage/live", "Live"],
      ["/creators", "Creators"],
      ["/circles", "Circles"],
      ["/collabs", "Collab"],
      ["/stage/news", "News"],
      ["/stage/sports", "Sports"],
      ["/stage", "About Stage"],
    ],
  },
  {
    title: "Business",
    links: [
      ["/business", "For business"],
      ["/pricing", "Pricing"],
      ["/membership", "Membership"],
      ["/agents", "Your agents"],
      ["/partner/start", "Start selling"],
      ["/business#register", "Register interest"],
      ["/payments", "Payments"],
    ],
  },
  {
    title: "Company",
    links: [
      ["/about", "About"],
      ["/blog", "Blog"],
      ["/careers", "Careers"],
      ["/help", "Help centre"],
      ["/guidelines", "Community guidelines"],
      ["/contact", "Contact"],
    ],
  },
  {
    title: "Legal",
    links: [
      ["/legal/terms", "Terms"],
      ["/legal/privacy", "Privacy"],
      ["/legal/cookies", "Cookies"],
      ["/about/sitemap", "Sitemap"],
        ["/accessibility", "Accessibility"],
      ["/legal/affiliate-disclosure", "Affiliate disclosure"],
    ],
  },
];

export function Footer() {
  const company = useCompany();
  return (
    <footer className="mt-20 border-t border-border bg-muted/40">
      <div className="mx-auto grid max-w-7xl gap-8 px-4 py-12 sm:px-6 md:grid-cols-3 lg:grid-cols-7">
        <div className="md:col-span-3 lg:col-span-1">
          <Logo className="text-2xl" />
          <p className="mt-3 max-w-xs text-sm text-muted-foreground">One account for everything you book and everyone you follow, across the UK.</p>
          <a href={`mailto:${SITE.email}`} className="mt-3 inline-block break-all text-sm font-medium text-foreground/80 hover:text-primary">{SITE.email}</a>
        </div>
        <div>
          <h4 className="mb-3 text-xs font-semibold uppercase tracking-wide text-muted-foreground">Worlds</h4>
          <ul className="space-y-2 text-sm">
            {WORLDS.map((w) => (
              <li key={w.key}>
                <Link to={`/worlds/${w.key}`} className="text-foreground/80 hover:text-primary">{w.name}</Link>
              </li>
            ))}
          </ul>
        </div>
        {COLS.map((c) => (
          <div key={c.title}>
            <h4 className="mb-3 text-xs font-semibold uppercase tracking-wide text-muted-foreground">{c.title}</h4>
            <ul className="space-y-2 text-sm">
              {c.links.map(([to, label]) => (
                <li key={to}>
                  <Link to={to} className="text-foreground/80 hover:text-primary">{label}</Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mx-auto mb-6 flex max-w-7xl flex-col gap-3 border-b border-border px-4 pb-6 sm:flex-row sm:items-center sm:justify-between sm:px-6" data-testid="footer-partners">
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
            <span className="text-[11px] font-semibold uppercase tracking-[0.18em] text-muted-foreground">Partnered with</span>
            {[["Stripe", "https://stripe.com", "Payments"], ["Duffel", "https://duffel.com", "Flights"], ["Travelpayouts", "https://www.travelpayouts.com", "Travel deals"], ["Klook", "https://www.klook.com", "Tours & activities"], ["Tiqets", "https://www.tiqets.com", "Attraction tickets"], ["Airalo", "https://www.airalo.com", "eSIMs"], ["Welcome Pickups", "https://www.welcomepickups.com", "Airport transfers"]].map(([n, u, w]) => (
              <a key={n} href={u} target="_blank" rel="noopener sponsored" title={w} className="text-base font-bold tracking-tight text-foreground/80 transition-colors hover:text-foreground">{n}</a>
            ))}
          </div>
          <p className="text-xs text-muted-foreground">Sports data &amp; photos: TheSportsDB · Maps: © OpenStreetMap contributors · Images: Wikimedia Commons</p>
        </div>
        <div className="border-t border-border px-4 py-5 text-center text-xs text-muted-foreground sm:px-6">
        <p>{company?.footer || "© 2026 Mamour Media × Fable +. All rights reserved."}</p>
        <p className="mx-auto mt-1 max-w-3xl">{companyLine(company)}</p>
      </div>
    </footer>
  );
}
